
$(document).ready(function () {
  variants();

  function variants() {
    // Check if .bf_radio_field input exists and is selected
    if ($(".bf_radio_field input").length === 0 || $(".bf_radio_field input:checked").length === 0) {
      console.log("No radio buttons found or none selected, stopping script.");
      return;
    }

    let c = "";
    $(".bf_radio_field input:checked").each(function () {
      c += $(this).val() + " / ";

      // Update the corresponding span inside .custom_opt_name
      let selectedValue = $(this).val();
      $(this).closest(".cstm_variant_flx").prev(".custom_opt_name").find("span").text(selectedValue);
    });

    console.log(c);
    let finall = c.substring(0, c.length - 3);
    console.log(finall);
    let flag = false;

    $(".master-select option").each(function () {
      if ($(this).text().trim() == finall) {
        flag = true;
      }
    });

    if (flag == true) {
      $(".master-select").children("option").each(function () {
        if ($(this).text().trim() == finall) {
          if (parseInt($(this).attr("viq")) > 0) {
            console.log("variant quantity", parseInt($(this).attr("viq")));

            let selectedValue = $(this).val();
            $(".master-select").val(selectedValue).trigger("change");
            $(".product-variant-id").val(selectedValue);

            let variant_price = $(this).attr("data-pr");
            let compare_variant_price = $(this).attr("data-compare-at-price");
            let discount_per = $(this).attr("data-save");

            $(".custom_new_pr .price-item.price-item--sale").empty().append(variant_price);
            $(".custom_new_pr .price-item.price-item--regular").empty().append(compare_variant_price);
            $(".custom_new_pr .discount-badge").empty().append(`${discount_per} korting`);

            $(".custom_new_pr .product-form__submit").prop("disabled", false);
            $(".custom_new_pr .product-form__submit span").text("In winkelwagen+");
          } else {
            console.log("This product is sold out");
            $(".custom_new_pr .product-form__submit").prop("disabled", true);
            $(".custom_new_pr .product-form__submit span").text("Uitverkocht");
          }
        }
      });
    } else {
      console.log("not available");
      $(".custom_new_pr .product-form__submit").prop("disabled", true);
      $(".custom_new_pr .product-form__submit span").text("niet beschikbaar");
    }
  }

  $(document).on("change", ".bf_radio_field input", function () {
    variants();
  });
});

 

    //    $('.shp--now--btn').click(function(){     
    //   var f = $('.my_form').serialize();
    //   var vid = $('.master-select').find('option:selected').attr('value');
    //   // var qty = $('.custom-product-qty-inp').val();
    //    var qty = $('.product-quantity_opt').find('option:selected').attr('value');
    //   data={
    //     quantity:qty,
    //     id:vid
    //   };
    //   $.ajax({
    //     type: "POST",
    //     url: "/cart/add.js",
    //     dataType: "json",
    //     data: data,
    //     success:function(){          
    //       var success_msg = 'Thank you';
    //     $(".txt-btn-atc").text(success_msg);
    //       setTimeout(function(){          
    //           $(".txt-btn-atc").text("Add to cart");        
    //       },2000);
    //     }, 
    //     error:function(msg){
    //       console.log(JSON.parse(msg.responseText).description,"Response");
    //       var msg = JSON.parse(msg.responseText).description;
    //     },complete:function(){
    //     }
    //   });
    // }); 